'use client';

import { useState, useEffect } from 'react';
import { Calendar, ChevronUp, GitCompare } from 'lucide-react';
import { useCompareUI } from '@/lib/compare-ui-store';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const { open: openCompare } = useCompareUI();

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 700);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={`fixed bottom-5 right-5 z-40 flex flex-col items-end gap-2.5 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      {/* Compare button */}
      <button
        onClick={openCompare}
        className="group inline-flex items-center gap-2.5 px-4 py-3 border border-[#D4AF37]/45 bg-[#0a0a0f]/85 backdrop-blur-sm text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0a0a0f] transition-all duration-300 text-[11px] uppercase tracking-[0.18em] font-semibold"
        aria-label="Comparer les pièces"
      >
        <GitCompare size={14} />
        <span className="hidden sm:inline">Comparer</span>
      </button>

      {/* Appointment button */}
      <a
        href="#contact"
        className="group inline-flex items-center gap-2.5 px-5 py-3 bg-gold-gradient text-[#0a0a0f] font-semibold uppercase tracking-[0.18em] text-[11px] shadow-2xl hover:glow-gold-strong transition-all duration-500"
        aria-label="Prendre rendez-vous"
      >
        <Calendar size={14} />
        <span className="hidden sm:inline">Rendez-vous</span>
        <span className="sm:hidden">RDV</span>
      </a>

      {/* Back to top */}
      <button
        onClick={scrollToTop}
        aria-label="Retour en haut"
        className="w-11 h-11 flex items-center justify-center border border-[#D4AF37]/45 bg-[#0a0a0f]/85 backdrop-blur-sm text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0a0a0f] transition-all duration-300"
      >
        <ChevronUp size={20} />
      </button>
    </div>
  );
}
